module.exports = __webpack_public_path__ + "img/icon_h-hospital.114bb29e.png";